/**
 * @module constants
 * @description Barrel export for application constants
 */

export {
  TITLE,
  SUBTITLE,
  SUBMISSION_STATUS,
  SECTIONS,
  EMPLOYMENT_STATUS,
  TERMINATION_REASONS,
  TIME_LOST_UNITS,
} from './constants';
